import { render, staticRenderFns } from "./RestaurationIcon.vue?vue&type=template&id=bc12838e"
import script from "./RestaurationIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./RestaurationIcon.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports